// AppTimePicker.jsx
// Time-only sibling of AppDateTimePicker (see that file for the full rationale).
// MUI <TimePicker> that opens the clock when the user clicks ANYWHERE in the
// field (not just the clock icon); manual typing still works. Bundles its own
// <LocalizationProvider> (AdapterMoment). Value/onChange are moment in / moment
// out — the call-site owns conversion to/from the stored string format.

import React, { useState } from "react";
import PropTypes from "prop-types";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export default function AppTimePicker({ slotProps = {}, ...pickerProps }) {
  const [open, setOpen] = useState(false);
  const { textField, ...restSlotProps } = slotProps;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        // Match the familiar old flatpickr 24h display ("08:46").
        // Placed before {...pickerProps} so a call-site can still override.
        format="HH:mm"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        {...pickerProps}
        slotProps={{
          ...restSlotProps,
          textField: {
            fullWidth: true,
            size: "small",
            ...textField,
            onClick: (e) => {
              setOpen(true);
              textField?.onClick?.(e);
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}

AppTimePicker.propTypes = {
  slotProps: PropTypes.object,
};
